module.exports = __webpack_public_path__ + "static/media/climateSeed.367dd25a.svg";